import { LiteHistoryActionTypes } from './liteHistoryActionsConstants';

// Lite-only history action creators. Match the legacy shapes 1:1 so the
// reducer / consumer code is straightforward; only the type strings differ.

export function PUT_LITE_PANELS_IN_HISTORY(panels) {
  return {
    type: LiteHistoryActionTypes.PUT_LITE_PANELS_IN_HISTORY,
    payload: { panels },
  };
}

export function LITE_UNDO_HISTORY() {
  return { type: LiteHistoryActionTypes.LITE_UNDO_HISTORY };
}

export function LITE_REDO_HISTORY() {
  return { type: LiteHistoryActionTypes.LITE_REDO_HISTORY };
}

// Reset the lite history with `panels` as the single "anchor" snapshot
// (canUndo=false until the user makes a fresh edit). Used by the workspace
// container after a project loads so undo can't walk past the loaded state.
export function LITE_SEED_HISTORY(panels) {
  return {
    type: LiteHistoryActionTypes.LITE_SEED_HISTORY,
    payload: { panels },
  };
}

// Restore a previously-saved full history state. Used when switching
// between roof areas so each roof keeps its own undo stack.
export function LITE_RESTORE_HISTORY(historyState) {
  return {
    type: LiteHistoryActionTypes.LITE_RESTORE_HISTORY,
    payload: historyState,
  };
}
